import Textfield from '@atlaskit/textfield';
import * as React from 'react';
import { getCurrencyPlaceholder, getCurrencySymbol } from '@atlassian/cssxp-utils-generic';

export type Props = React.ComponentProps<typeof Textfield> & {
  currency?: string | null;
  key?: string | number;
};

const CurrencyTextfield = (props: Props) => {
  const { currency, ...textFieldProps } = props;

  return (
    <Textfield
      {...textFieldProps}
      elemBeforeInput={
        <span className="currency-label">
          {currency} {getCurrencySymbol(currency)}
        </span>
      }
      placeholder={getCurrencyPlaceholder(currency)}
    />
  );
};

export default CurrencyTextfield;
